import { render, staticRenderFns } from "./admin-rooms.vue?vue&type=template&id=24d7c470&"
import script from "./admin-rooms.vue?vue&type=script&lang=js&"
export * from "./admin-rooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports